<template>
  <div style="height: 100%;">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="lastHeaderColumns" slot-scope="props">
        <grid-table-th
          v-if="props.magicalMenuCodes.includes('auditOperation')"
          width="60px"
        >操作</grid-table-th>
      </template>
      <template slot="lastBodyColumns" slot-scope="props">
        <template v-if="props.magicalMenuCodes.includes('auditOperation')">
          <grid-table-td
            width="60px"
            @click.native="handleAudit(props, 'pass')"
          >通过</grid-table-td>
          <grid-table-td
            width="60px"
            @click.native="handleAudit(props, 'reject')"
          >驳回</grid-table-td>
        </template>
      </template>
    </grid>

    <!-- 添加对话框组件 -->
    <whaty-dialog
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      title="操作"
      width="400px"
      @yes-btn-click="handleConfirm"
      @cancel="dialogVisible = false"
    >
      <div class="dialog-content">
        <el-form :model="formData" :rules="rules" ref="form" label-position="left" label-width="80px">
          <el-form-item label="审核结果" prop="status">
            <el-select v-model="formData.status" placeholder="请选择">
              <el-option label="通过" value="pass"></el-option>
              <el-option label="驳回" value="reject"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="formData.remark"
              :rows="3"
              placeholder="请输入备注"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </whaty-dialog>
  </div>
</template>

<script>
import WhatyDialog from '../../../components/dialog/dialog.vue'
import Grid from '../../../components/grid/grid.vue'
import GridTableTh from '../../../components/grid-menu/grid-table-th.vue'
import GridTableTd from '../../../components/grid-menu/grid-table-td.vue'
import util from '../../../libs/util'

export default {
  name: 'paper-withdrawal-info',
  components: {GridTableTd, GridTableTh, Grid, WhatyDialog},
  data() {
    return {
      gridConfigUrl: '',
      currentRowData: null,
      dialogVisible: false,
      formData: {
        status: '',
        remark: ''
      },
      rules: {
        status: [
          { required: true, message: '请选择审核结果', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
  },
  methods: {
    handleAudit(props, status) {
      console.log('通过按钮点击事件的props:', props.row.auditStatus)
      if (props.row.auditStatus !== '待审核') {
        this.$message.warning('此提现已经审核过，请勿重复审核')
        return
      }
      this.currentRowData = props.row
      this.formData = {
        status: status,
        remark: ''
      }
      this.dialogVisible = true
    },

    handleConfirm() {
      if (!this.formData.status) {
        this.$message.error('没有填入审核意见')
        return
      }
      const params = {
        withdrawId: this.currentRowData.id,
        auditResult: this.formData.status === 'pass' ? '1' : '2',
        remark: this.formData.remark
      }

      util.ajax.post('/entity/dev/paperWithdrawalInfo/auditWithdraw', params)
        .then(res => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({
              title: '成功',
              message: '审核操作成功'
            })
            this.dialogVisible = false
            this.$refs.myGrid.loadTableData()
          } else {
            this.$notify.error({
              title: '错误',
              message: res.data.meta.errMsg || '审核操作失败'
            })
          }
        })
        .catch(error => {
          console.error('审核请求失败:', error)
          this.$notify.error({
            title: '错误',
            message: '审核操作失败'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/custom/components/paper/paper-withdrawal-info.vue